const bookingFormUrlToDomain = (url: string): string => {
    const matches = url.match(/^https:\/\/\[tenantId]\.(.*)\/\[locale]\/.*$/);

    return matches?.[1] ?? '';
};

export default bookingFormUrlToDomain;
